import "./switch.css";

export default function Switch({ name, value, disabled, label, onChange }) {

   return (
      <div className="switch">
         <div
            className={ "switch-box " + ( value ? "checked" : "" ) + ( disabled ? " disabled" : "" )}
            role="switch"
            aria-checked={value}
            aria-disabled={disabled}
            aria-label={label || name}
            tabIndex={disabled ? -1 : 0}
            onClick={() => !disabled && onChange && onChange( name, !value )}
            onKeyDown={(e) => {
               if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  onChange && onChange( name, !value );
               }
            }}
         >
            <div aria-hidden="true"/>
         </div>

         { label && 
            <div className={ "switch-label" + ( disabled ? " disabled" : "" )}> { label } </div>
         }
      </div>
   )
}